import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { CRM_OBJECT } from 'reference-resolvers-lite/constants/ReferenceTypes';
import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { isError, isLoading } from 'reference-resolvers-lite/Status';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { SkeletonText } from '../../loaders/SkeletonText';
import { getRecordHref } from '../utils/getRecordHref';
import { AvatarCell } from './AvatarCell';
import EmptyState from './EmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ResolvedCrmObjectCell = ({
  objectId,
  objectTypeId
}) => {
  // This caches the resolver internally
  const resolver = createStandardCachedResolver(CRM_OBJECT, objectTypeId);
  const {
    status,
    reference
  } = useFetchResolver(resolver, objectId);
  if (!objectId) {
    return /*#__PURE__*/_jsx(EmptyState, {});
  }
  if (isLoading(status) || !reference) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "loading-text"
    });
  }
  if (isError(status)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: objectId
    });
  }
  const label = reference.label || '--';
  if ([CONTACT_TYPE_ID, COMPANY_TYPE_ID].includes(objectTypeId)) {
    return /*#__PURE__*/_jsx(AvatarCell, {
      type: objectTypeId === CONTACT_TYPE_ID ? 'vid' : 'companyId',
      id: objectId,
      displayName: reference.label,
      href: getRecordHref(objectTypeId, objectId),
      children: label
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: label
  });
};
export default ResolvedCrmObjectCell;